import { createUseStyles } from 'react-jss';
const useFancyButtonStyles = createUseStyles(() => ({
    base: {
        display: 'flex',
        padding: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '10px',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        minWidth: '120px',
        transition: 'all 0.3s ease-out',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:disabled': {
            cursor: 'not-allowed',
            boxShadow: 'none'
        }
    },
    black: {
        color: 'white',
        background: `linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.16) 0%,
              rgba(0, 0, 0, 0) 100%
          ), #0e121b`,
        boxShadow: '0px 1px 2px 0px rgba(14, 18, 27, 0.48), 0px 0px 0px 1px #242628',
        '&:disabled': {
            color: 'rgba(255, 255, 255, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
        }
    },
    blue: {
        color: 'white',
        background: `linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.16) 0%,
            rgba(255, 255, 255, 0) 100%
        ), #335cff`,
        boxShadow: '0px 1px 2px 0px rgba(14, 18, 27, 0.24), 0px 0px 0px 1px #335cff',
        '&:disabled': {
            color: 'rgba(255, 255, 255, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
        }
    },
    white: {
        color: '#868686',
        background: `linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.16) 0%,
            rgba(255, 255, 255, 0) 100%
        ), #efefef`,
        boxShadow: '0px 1px 2px 0px rgba(14, 18, 27, 0.24), 0px 0px 0px 1px #ffffff',
        '&:disabled': {
            color: 'rgba(130, 130, 130, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
        }
    },
    iconLeft: {
        paddingRight: '6px'
    },
    iconRight: {
        paddingLeft: '6px'
    }
}));
export default useFancyButtonStyles;
